<template>
	<div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "CommonView",
	props: {
		formData: {
			type: Object,
		},
		element: {
			type: Object,
		},
	},
};
</script>
